'use client';

import { useEffect, useState } from 'react';
import type { TutorialDemo, TutorialDemoFrame } from '../tutorial';

/**
 * The frame a demo is showing, advancing on each frame's `hold` and looping back to the first. Starts
 * over whenever the demo itself changes.
 */
export function useTutorialDemo<BoardT, CellT>(demo: TutorialDemo<BoardT, CellT>): TutorialDemoFrame<CellT> {
  const [index, setIndex] = useState(0);

  useEffect(() => setIndex(0), [demo]);

  const hold = demo.frames[index]?.hold;
  useEffect(() => {
    if (hold === undefined) return;
    const timer = setTimeout(() => setIndex((i) => (i + 1) % demo.frames.length), hold);
    return () => clearTimeout(timer);
  }, [demo, index, hold]);

  return demo.frames[index] ?? demo.frames[0];
}
